import './window'
export { initIntroWidgets, initNewFeatureCenter, initFeedbackModal } from './manager'
